<template>
  <kst-action>
    <kst-action-item>
      <kst-button action-mode
        :module="Model.Item.Module"
        :moduleType="Model.Item.ModuleType.Edit"
        :urlParams="urlParams"
      />
    </kst-action-item>
  </kst-action>
</template>

<script>
import Model from "../StkModel.js";

export default {
  props: {
    row: Object
  },
  data: () => ({
    Model: Model
  }),
  computed: {
    urlParams() {
      return this.$kst.Route.getParams({
        [this.$kst.Enum.Param.ID]: this.row.ItemID
      });
    }
  }
}
</script>